const { StrategyManager } = require("./strategyManager.js");
const {getSTAMPriority} = require("./STAM.js");
const {getCPMPriority} = require("./CPM.js")
const {getFeaturePriority} = require("./Features.js")


//Initialise the straties which can be run on the client side
function initServerSideStrategies(){
    StrategyManager.registerStrategy("STAM", getSTAMPriority);
    StrategyManager.registerStrategy("CPM", getCPMPriority);
    StrategyManager.registerStrategy("Features", getFeaturePriority);
}

function setServerSideParameters(strategyName, parameters){
    StrategyManager.setParameters(strategyName, parameters);
}

module.exports = { initServerSideStrategies, setServerSideParameters}